import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { pluralize } from "../../../../common/helpers/helpers";
import { getVarsomeQueries } from "../../../../state/selectors/VariantDetails.selectors";
import HelperText from "../../../../components/atoms/HelperText";

const { shape, number } = PropTypes;

const QueryCount = ({ varsomeQueries }) => {
  if (varsomeQueries && varsomeQueries?.query_count) {
    return (
      <div className="varsome-inner-container varsome-text-center">
        {"This variant has been viewed "}
        <strong>{varsomeQueries.query_count}</strong>
        {pluralize(varsomeQueries.query_count, " time ", " times ")}
        on VarSome.
        <HelperText fieldDescriptionKey="Views on VarSome" />
      </div>
    );
  }

  return null;
};

QueryCount.propTypes = {
  varsomeQueries: shape({
    count_other_users: number,
    query_count: number,
  }),
};

QueryCount.defaultProps = {
  varsomeQueries: {},
};

const mapStateToProps = (state) => ({
  varsomeQueries: getVarsomeQueries(state),
});

export default connect(mapStateToProps)(QueryCount);
